import { FetchActions, createFetchActions } from '@syncfab/machine'

export interface AnalyticsEventTrackingPayload {
    event: string
    payload: any
}

export const TRACK_EVENT: FetchActions<AnalyticsEventTrackingPayload, void> = createFetchActions('TRACK_EVENT')
